import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  imports: [TranslatePipe],
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LoadingComponent {
  message = input<string>('LoadingComponent.pleaseWait')
  showInline = input<boolean>(false)
  showSmall = input<boolean>(false)
  showText = input<boolean>(true)
}
